export class Campaigns {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public notes_title: string;

  /**
   *
   */
  public prjId: number;

  /**
   *
   */
  public title: string;

  /**
   *
   */
  public idInCampaignsList: number;

  /**
   *
   */
  public item20: number;

  /**
   * Creates an instance of Campaigns.
   *
   * @param campaignsList the campaigns list
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public constructor(campaignsList: any) {
    this.id = campaignsList.id;
    this.notes_title = campaignsList.notes_title;
    this.prjId = campaignsList.prjId;
    this.title = campaignsList.title;
    this.idInCampaignsList = campaignsList.idInCampaignsList;
    this.item20 = campaignsList.item20;
  }
}
